export const requiredBase = message => value => (value ? undefined : `Необходимо указать ${message}`);

export const required = {
  req: value => (value ? undefined : 'Обязательное поле'),
  email: requiredBase('e-mail'),
  files: value => (value && value[0] ? undefined : 'Необходимо приложить документы'),
};

export const email = value =>
  (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Неверный формат e-mail' : undefined);

export const emailAvinfors = value =>
  (value && !/^[A-Z0-9._%+-]+@avinfors.ru$/i.test(value) ? 'Неверный формат e-mail' : undefined);

export const passwordCheck = (value) => {
  if (value.length >= 8 && /[a-zA-Z0-9]+/.test(value)) return undefined;
  return 'Пароль должен состоять из арабских цифр (0-9) и букв латинского алфавита (A-z) и содержать не менее 8 символов';
};
